import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PointOfInterest } from '../categories/categories.model';
import { NodeService } from '../../services/node-service/node-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PoiProfileService } from './poi-profile.service';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DeleteConfirmComponent } from '../delete-confirm/delete-confirm.component';

const SNACKBAR_DURATION = 4000;
export interface Tile {
  color: string;
  cols: number;
  rows: number;
  text: string;
}

@Component({
  selector: 'app-poi-profile',
  templateUrl: './poi-profile.component.html',
  styleUrls: ['./poi-profile.component.css'],
  standalone: false,
})
export class PoiProfileComponent implements OnInit, OnDestroy {
  poi!: PointOfInterest;
  suscription!: Subscription;
  suscriptionData!: Subscription;
  poiId!: number;
  center: google.maps.LatLngLiteral = { lat: 0, lng: 0 };
  zoom: number = 16;
  markerOptions: google.maps.MarkerOptions = { draggable: false };
  markerPositions: google.maps.LatLngLiteral[] = [];

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private nodeService: NodeService,
    private snackbar: MatSnackBar,
    private poiProfileService: PoiProfileService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {}

  openDialogToDelete() {
    const dialogRef = this.dialog.open(DeleteConfirmComponent);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.deletePoiClick();
    });
  }

  deletePoiClick(): void {
    this.poiProfileService.deletePoi(this.poiId).subscribe({
      next: () => {
        this.router.navigate(['category', this.poi?.categoryId]);
      },
      error: () => {
        this.openSnackBar('Ha ocurrido un error');
      },
    });
  }

  ngOnDestroy(): void {
    this.suscription?.unsubscribe();
    this.suscriptionData?.unsubscribe();
  }

  ngOnInit(): void {
    this.suscription = this.route.params.subscribe((params) => {
      this.poiId = parseInt(params['poiId']);

      const cachedPoi = this.nodeService.getPois().find((item) => item.id === this.poiId);
      if (cachedPoi) {
        this.putPoisInMap(cachedPoi);
      } else {
        this.loadPoiFromApi();
      }
    });
  }

  private loadPoiFromApi(): void {
    const categoryId: number = this.nodeService.getCategoryId();

    this.suscriptionData = this.poiProfileService.getPoi(this.poiId).subscribe({
      next: ({ body }) => {
        const response = body?.body ?? body;

        if (response?.label === 'category') {
          this.router.navigate(['/categories', categoryId]);
          return;
        }

        const pois = Array.isArray(response)
          ? response
          : Array.isArray(response?.data)
            ? response.data
            : Array.isArray(response?.body)
              ? response.body
              : response?.id !== undefined
                ? [response]
                : [];
        const poiSelected = pois.find((poi: PointOfInterest) => poi.id === this.poiId);

        if (poiSelected) {
          this.putPoisInMap(poiSelected);
        } else {
          this.openSnackBar('El punto de interés seleccionado no se encuentra en la base de datos');
        }
      },
      error: () => {
        this.openSnackBar('Ha ocurrido un error');
      },
    });
  }

  openSnackBar(message: string): void {
    this.snackbar.open(`${message}`, 'X', {
      duration: SNACKBAR_DURATION,
    });
  }

  putPoisInMap(poiSelected: PointOfInterest) {
    let position: google.maps.LatLngLiteral = { lat: poiSelected.lat!, lng: poiSelected.lng! };
    this.poi = poiSelected;
    this.center = position;
    this.markerPositions.push(position);
    this.cdr.detectChanges();
  }

  onMapInitialized(map: google.maps.Map): void {
    console.info('[GoogleMaps] POI profile map initialized', {
      center: map.getCenter()?.toJSON(),
      zoom: map.getZoom(),
    });
  }

  setPoisToEdit() {
    this.nodeService.setPoiToEdit(this.poi);
  }
}
